import tw, { styled } from 'twin.macro';

const ScaleControl = styled.div`
  ${tw`absolute left-0`}
  bottom: 36px;
  padding: 10px;
`;

export default ScaleControl;
